import api from '@/services/api'

// 供应商相关
export function getSupplierList(wholesalerId, keyword) {
  return api.get('/supplier/list', { params: { wholesalerId, keyword } })
}

export function getActiveSuppliers(wholesalerId) {
  return api.get('/supplier/active', { params: { wholesalerId } })
}

export function createSupplier(data) {
  return api.post('/supplier', data)
}

export function updateSupplier(id, data) {
  return api.put(`/supplier/${id}`, data)
}

export function deleteSupplier(id) {
  return api.delete(`/supplier/${id}`)
}

export function toggleSupplierStatus(id) {
  return api.put(`/supplier/${id}/toggle-status`)
}

// 进货单相关
export function getPurchaseOrderList(params) {
  return api.get('/purchase/list', { params })
}

export function getPurchaseOrderDetail(id, wholesalerId) {
  return api.get(`/purchase/${id}`, { params: { wholesalerId } })
}

export function createPurchaseOrder(data, wholesalerId, userId) {
  return api.post('/purchase', data, { params: { wholesalerId, userId } })
}

export function updatePurchaseOrder(id, data, wholesalerId) {
  return api.put(`/purchase/${id}`, data, { params: { wholesalerId } })
}

export function confirmPurchaseOrder(id, wholesalerId) {
  return api.post(`/purchase/${id}/confirm`, null, { params: { wholesalerId } })
}

export function receivePurchaseOrder(id, wholesalerId, operatorId) {
  return api.post(`/purchase/${id}/receive`, null, { params: { wholesalerId, operatorId } })
}

export function cancelPurchaseOrder(id, wholesalerId) {
  return api.post(`/purchase/${id}/cancel`, null, { params: { wholesalerId } })
}

export function addPayment(id, data, wholesalerId) {
  return api.post(`/purchase/${id}/payment`, data, { params: { wholesalerId } })
}

export function getPurchaseStats(wholesalerId) {
  return api.get('/purchase/stats', { params: { wholesalerId } })
}

// 进货支付相关
export function getPurchasePayments(id, wholesalerId) {
  return api.get(`/purchase/${id}/payments`, { params: { wholesalerId } })
}

export function payPurchaseOrder(id, data, wholesalerId, operatorId) {
  return api.post(`/purchase/${id}/pay`, data, { params: { wholesalerId, operatorId } })
}

export function confirmPurchasePayment(id, recordId, wholesalerId, operatorId) {
  return api.post(`/purchase/${id}/pay/${recordId}/confirm`, null, { params: { wholesalerId, operatorId } })
}

// 获取商品列表（用于选择进货商品）
export function getProductList(wholesalerId, keyword) {
  return api.get('/wholesaler/products', { params: { wholesalerId, keyword } })
}

// 获取仓库列表
export function getWarehouseList(wholesalerId) {
  return api.get('/warehouse/list', { params: { wholesalerId } })
}

// 税率配置相关
export function getActiveTaxRateConfigs(wholesalerId) {
  return api.get('/tax-rate-config/active', { params: { wholesalerId } })
}

export function getAllTaxRateConfigs(wholesalerId) {
  return api.get('/tax-rate-config', { params: { wholesalerId } })
}

export function createTaxRateConfig(data, wholesalerId) {
  return api.post('/tax-rate-config', data, { params: { wholesalerId } })
}

export function updateTaxRateConfig(id, data, wholesalerId) {
  return api.put(`/tax-rate-config/${id}`, data, { params: { wholesalerId } })
}

export function deleteTaxRateConfig(id, wholesalerId) {
  return api.delete(`/tax-rate-config/${id}`, { params: { wholesalerId } })
}

export function toggleTaxRateConfig(id, wholesalerId) {
  return api.post(`/tax-rate-config/${id}/toggle`, null, { params: { wholesalerId } })
}
